import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import { ButtonInterface } from 'common/types/entities/button-interface'
import React, { memo } from 'react'
import { BaseEditorButton } from 'src/editor/shared/entities/base-editor-button'

export interface NewButtonProps {
  entity: ButtonInterface
}

const ButtonNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ButtonInterface>) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <BaseEditorButton entity={entity} />
    </BaseEntityNew>
  )
}

export default memo(ButtonNew)
